export const sleep = (time: number) => new Promise((resolve) => setTimeout(resolve, time))

/**
 * @description 安全地将 JSON parse 成一个字符串
 * 使用时请对返回值显式定义类型，并且尽量试用 DeepPartial 包裹
 * e.g. const spec = (safeJSONParse(task?.params?.spec)) as DeepPartial<TaskParamsSpec>
 */
export const safeJSONParse = (str = '{}'): unknown => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return {}
  }
}

/**
 * 将形如 2.1.1 的版本号转换成数字，以方便比较
 * @param {string} version 
 * @returns {number}
 */
export const parseVersionToNumber = (version: string): number => {
  // e.g. version = 2.1.3
  const res = version.split('.').map(i => Number(i)) // ['2', '1', '3'] => [2, 1, 3]
  return res[0] * 10000 + res[1] * 100 + res[2] // 2 * 10000 + 1 * 100 + 3 = 20103
}